import { render } from "./Hero-Detail.vue?vue&type=template&id=6ea229a4&scoped=true"
import script from "./Hero-Detail.vue?vue&type=script&lang=js"
export * from "./Hero-Detail.vue?vue&type=script&lang=js"

import "./Hero-Detail.vue?vue&type=style&index=0&id=6ea229a4&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea229a4"]])

export default __exports__